import React from 'react';

const OFFSETS = {
  top:    { dx: 0,    dy: -180 },
  bottom: { dx: 0,    dy:  180 },
  left:   { dx: -180, dy: 0    },
  right:  { dx:  180, dy: 0    },
};

const ConnectedShapeOverlay = ({
  selectedId,
  elements,
  tool,
  stageRef,
  scale,
  nextColor,
  onSpawn,
}) => {
  if (!selectedId || tool !== 'select') return null;

  const el = elements.find((e) => e.id === selectedId);
  if (
    !el ||
    el.type === 'line' ||
    el.type === 'stamp' ||
    el.type === 'image' ||
    el.type === 'textbox'
  )
    return null;

  const stage = stageRef.current;
  if (!stage) return null;

  const node = stage.findOne(`#el_${selectedId}`);
  if (!node) return null;

  const abs = node.getAbsolutePosition();
  const stageBox = stage.container().getBoundingClientRect();

  let cx, cy, hw, hh;

  if (el.type === 'circle') {
    hw = (el.radius || 50) * scale;
    hh = hw;
    cx = stageBox.left + abs.x;
    cy = stageBox.top + abs.y;
  } else if (el.type === 'oval') {
    hw = (el.radiusX || 60) * scale;
    hh = (el.radiusY || 35) * scale;
    cx = stageBox.left + abs.x;
    cy = stageBox.top + abs.y;
  } else if (el.type === 'triangle' || el.type === 'diamond') {
    hw = (el.radius || 50) * scale;
    hh = hw;
    cx = stageBox.left + abs.x;
    cy = stageBox.top + abs.y;
  } else {
    hw = ((el.width || 120) / 2) * scale;
    hh = ((el.height || 70) / 2) * scale;
    cx = stageBox.left + abs.x + hw;
    cy = stageBox.top + abs.y + hh;
  }

  const PLUS_GAP = 20;
  const positions = {
    top:    { x: cx,           y: cy - hh - PLUS_GAP },
    bottom: { x: cx,           y: cy + hh + PLUS_GAP },
    left:   { x: cx - hw - PLUS_GAP, y: cy },
    right:  { x: cx + hw + PLUS_GAP, y: cy },
  };

  const handleSpawn = (dir) => {
    const { dx, dy } = OFFSETS[dir];
    const colors = nextColor();
    const newId = Date.now();

    const newEl = {
      ...el,
      id: newId,
      x: el.x + dx,
      y: el.y + dy,
      text: '',
      ...colors,
    };

    const newConnector = {
      id: newId + 1,
      fromId: selectedId,
      toId: newId,
    };

    onSpawn(newEl, newConnector, newId);
  };

  return (
    <>
      {Object.entries(positions).map(([dir, { x, y }]) => (
        <div
          key={dir}
          onClick={() => handleSpawn(dir)}
          style={{
            position: 'fixed',
            left: x - 13,
            top: y - 13,
            width: 26,
            height: 26,
            borderRadius: '50%',
            background: '#3b82f6',
            color: '#ffffff',
            fontSize: 20,
            fontWeight: 300,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            zIndex: 3000,
            boxShadow: '0 2px 10px rgba(59,130,246,0.45)',
            userSelect: 'none',
            lineHeight: 1,
            transition: 'transform 0.12s, background 0.12s',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'scale(1.25)';
            e.currentTarget.style.background = '#2563eb';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.background = '#3b82f6';
          }}
        >
          +
        </div>
      ))}
    </>
  );
};

export default ConnectedShapeOverlay;